import HTMLReactParser from "html-react-parser";


const RawHtml = ({ controlData }) => {
    return HTMLReactParser(controlData[0].Column1)
}

export default RawHtml